<template>
  <div
    v-if="name"
    class="dg-modal-background"
    @click="clickedAway"
  >
    <div
      class="dg-modal"
      @click.stop
    >
      <component
        :is="name"
        v-bind="otherProps"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import InvitationFormModal from "@/components/modals/InvitationFormModal"
  import InvitationLinkModal from "@/components/modals/InvitationLinkModal"

  export default {
    components: {
      InvitationFormModal,
      InvitationLinkModal,
    },
    props: {
      name: {
        required: true,
        type: String,
      },
      initialValues: {
        default: null,
        required: false,
        type: Object,
      },
      modalVariant: {
        default: null,
        required: false,
        type: String,
      },
      rallyId: {
        required: true,
        type: Number,
      },
    },
    computed: {
      otherProps() {
        const nonNameProps = Object.assign({}, this.$props)
        delete nonNameProps.name
        return nonNameProps
      }
    },
    methods: {
      ...mapActions("user", ["setModalProps"]),
      clickedAway() {
        this.setModalProps({})
      },
    },
  }
</script>
